import { useContext, ref, readonly } from "@nuxtjs/composition-api";
import { useApi } from "@wemade-vsf/composables";
import createWishlistGql from "./createWishlist.gql";
import guestWishlistGql from "./guestWishlist.gql";
import guestWishlistItemsCountGql from "./guestWishlistItemsCount.gql";
function useGuestWishlist() {
  const loading = ref(false);
  const error = ref({
    load: null,
    create: null,
    loadItemsCount: null
  });
  const cookieName = "vsf-wishlist";
  const { app } = useContext();
  const { query, mutate } = useApi();
  const load = async (params = {}) => {
    let result = null;
    try {
      loading.value = true;
      let code = app.$cookies.get(cookieName);
      if (!code) {
        code = await create();
      }
      const searchParams = {
        pageSize: 100,
        currentPage: 1,
        ...params,
        code
      };
      const { data } = await query(guestWishlistGql, searchParams);
      result = (data == null ? void 0 : data.WmWishlist) || null;
      error.value.load = null;
    } catch (err) {
      error.value.load = err;
    } finally {
      loading.value = false;
    }
    return result;
  };
  const create = async () => {
    var _a;
    let result = "";
    try {
      loading.value = true;
      const { data } = await mutate(createWishlistGql);
      result = ((_a = data == null ? void 0 : data.WmCreateWishlist) == null ? void 0 : _a.sharing_code) || null;
      if (result) {
        app.$cookies.set(cookieName, result);
      } else {
        app.$cookies.remove(cookieName);
      }
      error.value.load = null;
    } catch (err) {
      error.value.load = err;
    } finally {
      loading.value = false;
    }
    return result;
  };
  const loadItemsCount = async () => {
    var _a;
    let result = null;
    try {
      loading.value = true;
      let code = app.$cookies.get(cookieName);
      if (!code) {
        result = null;
      } else {
        const { data } = await query(guestWishlistItemsCountGql, { code });
        result = ((_a = data == null ? void 0 : data.WmWishlist) == null ? void 0 : _a.items_count) || null;
      }
    } catch (err) {
      error.value.loadItemsCount = err;
    } finally {
      loading.value = false;
    }
    return result;
  };
  return {
    loading: readonly(loading),
    error: readonly(error),
    load,
    create,
    loadItemsCount
  };
}
export {
  useGuestWishlist
};
